import { styled, css } from "styled-components";
import { cssSpacing, surfaceColorMap } from "../util/styles.js";
import type { BackgroundColor } from "../types/theme.js";

export interface CardSurfaceProps {
  $bg?: BackgroundColor;
  $background?: string;
}

export const Card = styled.a<CardSurfaceProps>`
  ${(p) =>
    p.$bg
      ? css`
          background-color: ${surfaceColorMap[p.$bg]};
          color: ${p.$bg === "surface3" ? "#fff" : "var(--swatch2)"};
          svg path {
            fill: currentColor;
            stroke: currentColor;
          }
          && {
            h1,
            h2,
            h3,
            h4,
            h5,
            h6,
            p,
            span,
            .title,
            .rich-text {
              color: inherit;
            }
          }
        `
      : css`
          background-color: ${p.$background || "transparent"};
          color: var(--swatch2);
        `}
  display: flex;
  flex-direction: column;
  border-radius: ${(props) => props.theme.borderRadius};
  overflow: hidden;
  text-decoration: none;
`;

export const CardMedia = styled.img<{
  $height?: string;
  $aspectRatio?: string;
}>`
  display: block;
  width: 100%;
  object-fit: cover;
  ${(p) =>
    p.$height &&
    css`
      height: ${p.$height};
    `}
  ${(p) =>
    p.$aspectRatio &&
    css`
      aspect-ratio: ${p.$aspectRatio};
    `}
`;

export const CardBody = styled.div`
  padding: ${cssSpacing("s")};
`;
